import { BaseError } from './base.js';
export class InsufficientUTXOBalanceError extends BaseError {
    constructor({ minValue, address, balance, }) {
        super(`Not enough UTXOs required for ${minValue}`, {
            metaMessages: [
                `${address && balance && `Address ${address} has a balance of ${balance}.`}`,
            ],
            name: 'InsufficientUTXOBalanceError',
        });
    }
}
//# sourceMappingURL=utxo.js.map